export function leagueComparisonData(data) {
  function aggregateTable(table, prefix) {
    const rows = Array.isArray(table) ? table : [];

    const read = (row, location, field) => {
      const number = Number(row?.[location]?.[`${prefix}_${field}`]);

      return Number.isFinite(number) ? number : 0;
    };

    return rows.reduce(
      (summary, row) => {
        summary.fixtures += read(row, "home", "games_played");

        summary.homeWins += read(row, "home", "won");

        summary.draws += read(row, "home", "draw");

        summary.awayWins += read(row, "home", "lost");

        summary.homeGoals += read(row, "home", "goals_scored");

        summary.awayGoals += read(row, "away", "goals_scored");

        return summary;
      },
      {
        fixtures: 0,
        homeWins: 0,
        draws: 0,
        awayWins: 0,
        homeGoals: 0,
        awayGoals: 0,
      }
    );
  }

  const actualSummary = data?.season_base_summary;

  const actual = actualSummary
    ? {
        key: "actual",
        label: "Real",
        fixtures: Number(actualSummary.fixtures_played) || 0,
        homeWins: Number(actualSummary.home_wins) || 0,
        draws: Number(actualSummary.draws) || 0,
        awayWins: Number(actualSummary.away_wins) || 0,
        homeGoals: Number(actualSummary.home_goals) || 0,
        awayGoals: Number(actualSummary.away_goals) || 0,
      }
    : null;

  const expectedTable = data?.record?.expected_table;

  const expected =
    Array.isArray(expectedTable) && expectedTable.length > 0
      ? {
          key: "expected",
          label: "Expected",
          ...aggregateTable(expectedTable, "expected"),
        }
      : null;

  const shouldTable = data?.record?.should_table;

  const should =
    Array.isArray(shouldTable) && shouldTable.length > 0
      ? {
          key: "should",
          label: "Should",
          ...aggregateTable(shouldTable, "should"),
        }
      : null;

  const marketTable = data?.record?.market_table || data?.record?.market?.table;
  const market =
    Array.isArray(marketTable) && marketTable.length > 0
      ? {
          key: "market",
          label: "Market",
          ...aggregateTable(marketTable, "market"),
        }
      : null;

  const rows = [actual, expected, should, market].filter(Boolean);

  return rows;
}
